import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "./constants";

const LINKS = [
  { label: "The Service", href: "#venue", id: "venue" },
  { label: "The Trainer", href: "#trainer", id: "trainer" },
  { label: "Services", href: "#services", id: "services" },
  { label: "The Season", href: "#season", id: "season" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ebony/80 backdrop-blur-md border-b border-champagne/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#top")}
          className="group flex items-baseline gap-3"
        >
          <span className="font-serif text-2xl italic text-gold">KS</span>
          <span className="text-xs uppercase tracking-[0.3em] text-cream/80 transition-colors duration-300 group-hover:text-cream">
            Kiara Samson
          </span>
        </a>

        <nav className="hidden items-center gap-10 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              onClick={(e) => go(e, l.href)}
              className="text-xs uppercase tracking-[0.22em] text-cream/60 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#consultation"
            data-testid="nav-reserve-button"
            onClick={(e) => go(e, "#consultation")}
            className="border border-gold/60 px-6 py-2.5 text-xs uppercase tracking-[0.22em] text-gold transition-colors duration-500 hover:bg-gold hover:text-ebony"
          >
            Reserve
          </a>
        </nav>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="text-cream lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="border-t border-champagne/10 bg-ebony/95 backdrop-blur-md lg:hidden"
        >
          <div className="flex flex-col gap-6 px-6 py-8">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={(e) => go(e, l.href)}
                className="text-sm uppercase tracking-[0.22em] text-cream/70"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#consultation"
              data-testid="mobile-nav-reserve-button"
              onClick={(e) => go(e, "#consultation")}
              className="mt-2 border border-gold/60 px-6 py-3 text-center text-xs uppercase tracking-[0.22em] text-gold"
            >
              Reserve Winter Training
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
